import { useEffect, useState } from 'react'

import { getEvaluationOptOutExpirationDate, saveEvaluationOptOut } from '@/helpers/evaluationOptOut/evaluationOptOut'

const useEvaluationOptOut = () => {
  const [expirationDate] = useState(() => getEvaluationOptOutExpirationDate(new Date()))

  useEffect(() => {
    saveEvaluationOptOut(expirationDate)
  }, [expirationDate])

  return { expirationDate }
}

export default useEvaluationOptOut
